import React from 'react';
import { Skeleton } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useResolution886Report } from '@/context/Resolution886Report';
import { useGetPreventiveMeasures } from './hooks/useGetPreventiveMeasures';
import { TablePaginated } from './TablePaginated';

import * as S from './styles';

export function PreventiveMeasuresTable(): JSX.Element {
	const { report } = useResolution886Report();

	const { preventiveMeasures, isLoading } = useGetPreventiveMeasures(report);

	if (isLoading) {
		return (
			<>
				<div>
					<S.PreventiveMeasuresTitle>
						{I18n.get('Spreadsheet 3: Specific corrective and preventive measures')}
					</S.PreventiveMeasuresTitle>
					<S.CustomTable>
						<thead>
							<tr>
								<th style={{ width: '10%', textAlign: 'center' }}>No.</th>
								<th style={{ width: '70%', textAlign: 'center' }}>
									{I18n.get('General Preventive Measures')}
								</th>
								<th style={{ width: '20%', textAlign: 'center' }}>{I18n.get('Observations')}</th>
							</tr>
						</thead>
						<tbody>
							{[1, 2, 3].map((index) => (
								<tr key={index}>
									<td style={{ textAlign: 'center' }}>
										<Skeleton.Input active size="small" style={{ width: '20px' }} />
									</td>
									<td>
										<Skeleton.Input active size="default" style={{ width: '100%' }} />
									</td>
									<td style={{ textAlign: 'center' }}>
										<Skeleton.Input active size="small" style={{ width: '60px' }} />
									</td>
								</tr>
							))}
						</tbody>
					</S.CustomTable>
				</div>
				<TablePaginated />
			</>
		);
	}

	return (
		<>
			<div>
				<S.PreventiveMeasuresTitle>
					{I18n.get('Spreadsheet 3: Specific corrective and preventive measures')}
				</S.PreventiveMeasuresTitle>
				<S.CustomTable>
					<thead>
						<tr>
							<th style={{ width: '5%', textAlign: 'center' }}>No.</th>
							<th style={{ width: '50%', textAlign: 'center' }}>
								{I18n.get('General Preventive Measures')}
							</th>
							<th style={{ width: '45%', textAlign: 'center' }}>{I18n.get('Observations')}</th>
						</tr>
					</thead>
					<tbody>
						{preventiveMeasures.length === 0 ? (
							<tr>
								<td colSpan={3} style={{ textAlign: 'center', padding: '20px' }}>
									{I18n.get('No preventive measures found')}
								</td>
							</tr>
						) : (
							preventiveMeasures
								.sort((a, b) => a.preventive_measure.sequence - b.preventive_measure.sequence)
								.map((item, index) => (
									<tr key={item.id}>
										<td style={{ textAlign: 'center' }}>{index + 1}</td>
										<td>
											<div
												style={{
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center'
												}}
											>
												<span>{I18n.get(item.question)}</span>
												<span style={{ fontWeight: 'semibold', marginLeft: '20px' }}>
													{item.value === 'YES' ? I18n.get('Yes') : I18n.get('No')}
												</span>
											</div>
										</td>
										<td style={{ textAlign: 'center', wordBreak: 'break-word' }}>{I18n.get(item.description) || '-'}</td>
									</tr>
								))
						)}
					</tbody>
				</S.CustomTable>
			</div>
			<TablePaginated />
		</>
	);
}
